export const isStream = process.env.GATSBY_IS_STREAM === 'true';
export const contactApiUrl = process.env.GATSBY_API_URL;
